import React, { PureComponent } from "react";
import classnames from "classnames";
import styles from "./style.module.css";
import { ReactComponent as ArrowLeft } from "./icons/arrow-left.svg";
import PropTypes from "prop-types";
import PerfectScrollbar from "react-perfect-scrollbar";

export default class CardLayout extends PureComponent {

  static propTypes = {
    rightHeaderLayout: PropTypes.any,
    title: PropTypes.string,
    children: PropTypes.any.isRequired,
    backButtonHandler: PropTypes.func,
  };

  static defaultProps = {
    rightHeaderLayout: undefined,
    showBackButton: true,
    backButtonHandler: undefined,
  };


  render() {
    const hasHeader = !!this.props.backButtonHandler || !!this.props.rightHeaderLayout || !!this.props.title;

    return (
      <div className={classnames(styles.container, this.props.className)}>
        <div className={classnames(styles.header, { [styles.withContent]: hasHeader })}>
          <div className={styles.backButtonContainer}>
            {
              !!this.props.backButtonHandler &&
              <ArrowLeft
                onClick={this.props.backButtonHandler}
                className={styles.backButton}
              />
            }
          </div>
          <h5 className={styles.title}>
            {this.props.title}
          </h5>
          <div className={styles.rightHeaderLayout}>
            {this.props.rightHeaderLayout}
          </div>
        </div>
        <PerfectScrollbar className={styles.content}>
          {this.props.children}
        </PerfectScrollbar>
        {
          this.props.footer &&
          <div className={styles.footer}>
            {this.props.footer}
            <p className={styles.poweredBy}>powered by <a target="_blank" href={"https://tecorien.com/"}>Technology Oriented</a></p>
          </div>
        }
      </div>
    );
  }
};
